module.exports = __webpack_public_path__ + "static/media/africa_w2.7501775e.jpg";